<template>
    <form @submit.prevent="submit">
        <div class="columns">
            <div class="column">
                <b-field :label="$t('global.forms.firstName')"
                         :type="{'is-danger': veeErrors.has('first_name')}"
                         :message="veeErrors.first('first_name')">
                    <b-input v-model="first_name" name="first_name"
                             v-validate="'required'" :data-vv-as="$t('global.forms.firstName')" />
                </b-field>
            </div>

            <div class="column">
                <b-field :label="$t('global.forms.lastName')"
                         :type="{'is-danger': veeErrors.has('last_name')}"
                         :message="veeErrors.first('last_name')">
                    <b-input v-model="last_name" name="last_name"
                             v-validate="'required'" :data-vv-as="$t('global.forms.lastName')" />
                </b-field>
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <b-field :label="$t('global.forms.phoneNumber')"
                         :type="{'is-danger': veeErrors.has('phoneNumber')}"
                         :message="veeErrors.first('phoneNumber')">
                    <b-input v-model="phone_number" type="phone" name="phoneNumber"
                             v-validate="'required|min:8'" :data-vv-as="$t('global.forms.phoneNumber')" />
                </b-field>
            </div>

            <div class="column">
                <b-field :label="$t('global.forms.email')"
                         :type="{'is-danger': veeErrors.has('email')}"
                         :message="veeErrors.first('email')">
                    <b-input v-model="email" type="email" name="email"
                             v-validate="'required|email'" :data-vv-as="$t('global.forms.email')" />
                </b-field>
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <b-field label="Hvor har du hørt om os fra?">
                  <b-select v-model="referral" placeholder="Vælg et sted">
                    <option value="friend">Fra en ven/bekendt</option>
                    <option value="google">Via Google-søgning</option>
                    <option value="facebook">Facebook</option>
                    <option value="linkedin">LinkedIn</option>
                    <option value="article">Artikel</option>
                    <option value="other">Andet</option>
                  </b-select>
                </b-field>

                <b-field v-if="referral === 'other'" label="Andet:">
                    <b-input v-model="referralOther" type="text" name="andet"
                             v-validate="'required'" data-vv-as="andet" />
                </b-field>
            </div>

            <div class="column">
              <b-checkbox v-model="newsletter">
                Ønsker du at modtage vores nyhedsbrev?
              </b-checkbox>
            </div>
        </div>

        <div class="buttons is-right">
            <button type="submit" class="button is-primary" :class="{'is-loading': isSubmitting}"  :disabled="veeErrors.any()">
                <span>{{$t('global.actions.register')}}</span>
            </button>
        </div>
    </form>
</template>

<script>
    import CustomerService from '@/taskflex/customers/services/CustomerService';

    export default {
        data() {
            return {
                first_name: null,
                last_name: null,
                email: null,
                phone_number: null,
                referral: null,
                referralOther: null,
                isSubmitting: false,
                newsletter: false,
            };
        },

        methods: {
            async submit() {
                if (!await this.$validator.validateAll()) {
                    return;
                }

                this.isSubmitting = true;

                const data = {
                    first_name: this.first_name,
                    last_name: this.last_name,
                    email: this.email,
                    phone_number: this.phone_number,
                    newsletter: this.newsletter,
                };

                if (this.referral) {
                    data.referral = this.referral;

                    if (this.referral === 'other') {
                        data.referral = `other: ${this.referralOther}`;
                    }
                }

                CustomerService.create(data, ({ data: { data: customer } }) => {
                    this.isSubmitting = false;

                    this.$emit('registered', customer);
                }, ({ response }) => {
                    const { errors } = response.data;

                    // TODO: make into mixin?
                    Object.entries(errors).forEach(([key, values]) => {
                        values.forEach((value) => {
                            if (value === 'validation.unique') {
                                this.veeErrors.add({
                                    field: key, // TODO: seems locked to one mail
                                    msg: 'Denne email er allerede registeret i vores system.', // TODO: Translate
                                });
                            }
                        });
                    });

                    this.isSubmitting = false;
                });
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/customers/components/QuickCustomerRegistration.vue